<template>
    <v-container fluid style="margin: 60px 10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.AdministracionProductos') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
          <v-col cols="12" align="center">
                <v-btn @click="eleccion = 'pendientes'" outlined class="ma-2" style="border: 2px solid;">{{$t('Administracion.Pendientes')}}</v-btn>
                <v-btn @click="eleccion = 'finalizados'" outlined class="ma-2" style="border: 2px solid;">{{$t('Administracion.Finalizados')}}</v-btn>
            </v-col>
            <v-col cols="12">
              <v-text-field solo v-model="buscar" :label="$t('Busqueda.Buscar')"></v-text-field>
                <v-data-table
                :search="buscar"
                :headers="headerProductos"
                :items="productos">
                    <template v-slot:[`item.acciones`]="{ item }">
                        <v-icon class="mx-2" color="black" @click="revisarProducto(item)">far fa-eye</v-icon>
                    </template>
                </v-data-table>
                <v-dialog v-model="dialog" v-if="seleccionado">
                    <v-card>
                        <v-card-title>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" align="center" class="mb-5">
                                        <h1>{{$t('Formularios.RevisarProducto')}}</h1>
                                        <span>{{seleccionado.referencia}}</span>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2 class="display-1">{{seleccionado.titulo}}</h2>
                                        <span class="headline">{{$t('Categoria.'+ seleccionado.subcategoria)}}</span>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2 class="headline">{{seleccionado.artista.nombre}}</h2>
                                        <span>{{seleccionado.artista.pais}}</span>
                                    </v-col>
                                    <v-col cols="12" align="center" v-if="seleccionado.exponer">
                                        <h2 class="accent--text">{{$t('Formularios.Exponer')}}</h2>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col cols="12" xs="12" md="6" v-if="seleccionado.fisico && !seleccionado.exponer">
                                                <span>Creative Commons: </span>
                                                <v-icon color="green" v-if="seleccionado.aceptarCreatC">fas fa-check</v-icon>
                                                <v-icon color="red" v-else>fas fa-times</v-icon>
                                                <br>
                                                <span>{{$t('Formularios.CantidadFisico')}}: {{seleccionado.cantidadFisico}}</span>
                                                <br>
                                                <span>{{$t('Formularios.TipoMoneda')}}: {{tipoMoneda }}</span>
                                                <br>
                                                <span>{{$t('Formularios.PrecioFisico')}}: {{seleccionado.precioPago }}</span>
                                                <br>
                                                <span>Iva: </span>
                                                <v-icon color="green" v-if="seleccionado.iva">fas fa-check</v-icon>
                                                <v-icon color="red" v-else>fas fa-times</v-icon>
                                                <br>
                                                <span>{{$t('Formularios.CostoEnvio')}}: {{seleccionado.costeEnvio }}</span>
                                                <br>
                                                <span>{{$t('Carrito.Descuento')}}: {{seleccionado.DescuentoFisico}}</span>
                                            </v-col>
                                            <v-col cols="12" xs="12" md="6" v-if="seleccionado.digital && !seleccionado.exponer">
                                                <span>Creative Commons: </span>
                                                <v-icon color="green" v-if="seleccionado.aceptarCreatC">fas fa-check</v-icon>
                                                <v-icon color="red" v-else>fas fa-times</v-icon>
                                                <br>
                                                <span v-if="!seleccionado.ilimitado">{{$t('Formularios.CantidadDigital')}}: {{seleccionado.cantidadDigital}}</span>
                                                <span v-else>{{$t('Formularios.CantidadDigital')}}: {{$t('Formularios.Ilimitado')}}</span>
                                                <br>
                                                <span>{{$t('Formularios.TipoMoneda')}}: {{tipoMoneda }}</span>
                                                <br>
                                                <span>{{$t('Formularios.PrecioDigital')}}: {{seleccionado.precioPagoDig }}</span>
                                                <br>
                                                <span>{{$t('Carrito.Descuento')}}: {{seleccionado.DescuentoDigital}}</span>
                                            </v-col>
                                        </v-row>
                                        <v-divider></v-divider>
                                    </v-col>
                                     <v-col cols="12" align="center">
                                        <h2 class="mb-5">{{$t('Formularios.Etiqueta')}}</h2>
                                        <v-row>
                                              <v-col v-for="item in seleccionado.etiquetas" :key="item" cols="6" xs="6" md="3" align="center">
                                                <span>{{item}}</span>
                                              </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2 class="mb-5">{{$t('Formularios.Dimensiones')}}</h2>
                                        <v-row>
                                            <v-col cols="6" xs="6" md="3" align="center">
                                                <span>{{$t('Formularios.Alto')}}</span>
                                                <br>
                                                <span>{{seleccionado.dimensiones.alto}}</span>
                                            </v-col>
                                            <v-col cols="6" xs="6" md="3" align="center">
                                                <span>{{$t('Formularios.Ancho')}}</span>
                                                <br>
                                                <span>{{seleccionado.dimensiones.ancho}}</span>
                                            </v-col>
                                            <v-col cols="6" xs="6" md="3" align="center">
                                                <span>{{$t('Formularios.Largo')}}</span>
                                                <br>
                                                <span>{{seleccionado.dimensiones.largo}}</span>
                                            </v-col>
                                            <v-col cols="6" xs="6" md="3" align="center">
                                                <span>{{$t('Formularios.Peso')}}</span>
                                                <br>
                                                <span>{{seleccionado.dimensiones.peso}}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <!-- PRODUCTO EMPACADO -->
                                    <v-col cols="12" align="center">
                                        <h2 class="mb-5">{{$t('Formularios.DimensionesEmpacado')}}</h2>
                                        <v-row>
                                            <v-col cols="6" xs="6" md="3" align="center">
                                                <span>{{$t('Formularios.Alto')}}</span>
                                                <br>
                                                <span>{{seleccionado.dimensiones.altoEmpacado}}</span>
                                            </v-col>
                                            <v-col cols="6" xs="6" md="3" align="center">
                                                <span>{{$t('Formularios.Ancho')}}</span>
                                                <br>
                                                <span>{{seleccionado.dimensiones.anchoEmpacado}}</span>
                                            </v-col>
                                            <v-col cols="6" xs="6" md="3" align="center">
                                                <span>{{$t('Formularios.Largo')}}</span>
                                                <br>
                                                <span>{{seleccionado.dimensiones.largoEmpacado}}</span>
                                            </v-col>
                                            <v-col cols="6" xs="6" md="3" align="center">
                                                <span>{{$t('Formularios.Peso')}}</span>
                                                <br>
                                                <span>{{seleccionado.dimensiones.pesoEmpacado}}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" v-if="seleccionado.color" align="center">
                                        <h2>{{$t('Oficina.Colores')}}</h2>
                                        <v-row>
                                            <v-col cols="6" v-for="i in seleccionado.colores" :key="i.tituloColor" align="center">
                                                <v-avatar :color="i.color.hex" size="50" />
                                                <br>
                                                <span>{{i.tituloColor}}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" v-if="seleccionado.talla" align="center">
                                        <h2>{{$t('Oficina.Tallas')}}</h2>
                                        <span v-for="i in seleccionado.tallas" :key="i"> {{i}} /</span>
                                        <br>
                                        <v-img :src="seleccionado.tablaDeTallas" contain />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-img :src="seleccionado.imagenPrincipal" contain max-height="600" />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col cols="4" v-for="i in seleccionado.imagenes" :key="i">
                                                <v-img :src="i" contain />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.DescripcionEs')}}</h2>
                                        <p>{{seleccionado.descripcion}}</p>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.DescripcionEn')}}</h2>
                                        <p>{{seleccionado.descripcionEn}}</p>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.CuidadosEs')}}</h2>
                                        <p>{{seleccionado.cuidados}}</p>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.CuidadosEn')}}</h2>
                                        <p>{{seleccionado.cuidadosEn}}</p>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.MaterialesEs')}}</h2>
                                        <p>{{seleccionado.materiales}}</p>
                                    </v-col>
                                     <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.MaterialesEn')}}</h2>
                                        <p>{{seleccionado.materialesEn}}</p>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.TecnicaEs')}}</h2>
                                        <p>{{seleccionado.tecnica}}</p>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.TecnicaEn')}}</h2>
                                        <p>{{seleccionado.tecnicaEn}}</p>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.Estilo')}}</h2>
                                        <p>{{seleccionado.estilo}}</p>
                                    </v-col>
                                     <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.EstiloEn')}}</h2>
                                        <p>{{seleccionado.estiloEn}}</p>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.Orientacion')}}</h2>
                                        <p>{{seleccionado.orientacion}}</p>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2>{{$t('Formularios.OrientacionEn')}}</h2>
                                        <p>{{seleccionado.orientacionEn}}</p>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2 class="mb-5">{{$t('Oficina.Inventario')}}</h2>
                                        <v-data-table
                                        :headers="headerInventario"
                                        :items="seleccionado.inventario">
                                        <template v-slot:[`item.color`]="{ item }">
                                          <v-avatar v-if="seleccionado.color" :color="item.color.color.hex" max-height="90%"></v-avatar>
                                        </template>
                                        <template v-slot:[`item.tituloColor`]="{ item }">
                                          <span v-if="seleccionado.color">{{ item.color.tituloColor }}</span>
                                        </template>
                                        <template v-slot:[`item.talla`]="{ item }">
                                          <span v-if="seleccionado.talla">{{ item.talla }}</span>
                                        </template>
                                        </v-data-table>
                                    </v-col>
                                     <v-col align="center" cols="12" xs="12" md="12" v-if="seleccionado.video">
                                        <iframe :style="marginVideo" width="50%" :height="videoHeight" :src="`https://www.youtube.com/embed/${seleccionado.video}`" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                     </v-col>
                                    <v-col cols="12">
                                        <v-textarea solo v-model="comentario" :label="$t('Formularios.ComentarioDelModerador')" :hint="$t('Formularios.ComentarioDelModerador')" />
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <v-btn class="ma-3" outlined color="accent" x-large style="border: 2px solid" @click="dialog = false">{{$t('Formularios.Cerrar')}}</v-btn>
                                        <v-btn class="ma-3" outlined x-large style="border: 2px solid" @click="rechazar()">{{$t('Administracion.Rechazar')}}</v-btn>
                                        <v-btn class="ma-3" color="black white--text" x-large @click="aprobar()">{{$t('Administracion.Aprobar')}}</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-title>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapMutations, mapActions } from 'vuex'
export default {
  name: 'AdministracionProductos',
  data () {
    return {
      buscar: null,
      eleccion: null,
      productos: [],
      dialog: false,
      seleccionado: null,
      tipoMoneda: null,
      comentario: null,
      headerProductos: [
        { text: this.$i18n.t('Formularios.Producto'), value: 'titulo' },
        { text: this.$i18n.t('Formularios.Autor'), value: 'artista.nombre' },
        { text: this.$i18n.t('Formularios.Acciones'), value: 'acciones' }
      ],
      headerInventario: [
        { text: this.$i18n.t('Oficina.Color'), value: 'color', align: 'center' },
        { text: this.$i18n.t('Oficina.TituloColor'), value: 'tituloColor', align: 'center' },
        { text: this.$i18n.t('Oficina.Talla'), value: 'talla', align: 'center' },
        { text: this.$i18n.t('Oficina.Cantidad'), value: 'cantidad', align: 'center' }
      ]
    }
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta']),
    ...mapActions(['enviarCorreo']),
    revisarProducto (i) {
      this.seleccionado = i
      if (this.seleccionado.precioCOL) {
        this.tipoMoneda = 'COL'
      } else {
        this.tipoMoneda = 'USD'
      }
      this.dialog = true
      // console.log('hola', this.tipoMoneda)
    },
    computed: {
      videoHeight () {
        if (this.$vuetify.breakpoint.name === 'xl') {
          return '550px'
        } else {
          return '400px'
        }
      },
      marginVideo () {
        if (this.$vuetify.breakpoint.name !== 'xs' && this.$vuetify.breakpoint.name !== 'sm') {
          return 'margin-left: 15px'
        } else {
          return 'margin-left: 0px'
        }
      }
    },
    aprobar () {
      firebase.firestore().collection('productos').doc(this.seleccionado.uid).update({
        aprobado: true,
        revision: true
      })
        .then(() => {
          var index = this.productos.indexOf(this.seleccionado)
          this.productos[index].aprobado = true
          firebase.firestore().collection('usuarios').doc(this.seleccionado.artista.uid).get().then(info => {
            this.enviarCorreo({
              email: 'TrArtist <soycliente@trartist.com>',
              destino: info.data().email,
              asunto: this.$i18n.t('Formularios.AsuntoAprobado', { titulo: this.seleccionado.titulo }),
              texto: this.$i18n.t('Formularios.MensajeAprobado', { titulo: this.seleccionado.titulo, nombre: info.data().nombre, uid: this.seleccionado.uid })
            })
            this.setAlerta()
            this.setTextoAlerta('Alerta.ProductoAceptado')
            this.dialog = false
            this.productos.splice(index, 1)
          })
        })
    },
    rechazar () {
      firebase.firestore().collection('productos').doc(this.seleccionado.uid).update({
        aprobado: false,
        revision: true
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.ProductoRechazado')
          var index = this.productos.indexOf(this.seleccionado)
          this.productos[index].aprobado = false
          firebase.firestore().collection('usuarios').doc(this.seleccionado.artista.uid).get().then(info => {
            this.enviarCorreo({
              email: 'TrArtist <soycliente@trartist.com>',
              destino: info.data().email,
              asunto: this.$i18n.t('Formularios.AsuntoRechazado', { titulo: this.seleccionado.titulo }),
              texto: this.$i18n.t('Formularios.MensajeRechazado', { titulo: this.seleccionado.titulo, nombre: info.data().nombre, comentario: this.comentario })
            })
            this.dialog = false
          })
        })
    }
  },
  watch: {
    eleccion: function (nuevo, anterior) {
      if (nuevo === 'pendientes') {
        this.productos = []
        firebase.firestore().collection('productos').where('revision', '==', false).get().then(info => {
          if (info.docs.length === 0) {
            this.setAlerta()
            this.setTextoAlerta('No hay productos pendientes de revisión')
          }
          for (let i = 0; i < info.docs.length; i++) {
            this.productos.push(info.docs[i].data())
            // console.log('productos', this.productos)
          }
        })
      }
      if (nuevo === 'finalizados') {
        this.productos = []
        firebase.firestore().collection('productos').where('revision', '==', true).get().then(info => {
          for (let i = 0; i < info.docs.length; i++) {
            this.productos.push(info.docs[i].data())
          }
        })
      }
    }
  }
}
</script>
